(ns fen.main
  "Entry point. A window is a URL: the hash names the entity that is the
  root of it, so opening something in a second window is opening a second
  address - which is the whole reason this is a web app (see web-app)."
  (:require-macros [kc.core :refer [def-ui $]])
  (:require ["react-dom/client" :as rdom]
            [kc.core :as kc]
            [kc.spa :as spa]
            [fen.keys :as keyboard]
            [fen.mui :as mui]
            [fen.pwa :as pwa]
            [fen.screen :as screen]
            [fen.window :as window]))

(def-ui App []
  (let [page (spa/use-location-page)]
    (kc/use-effect
     [page]
     (window/root! (if (seq page) (keyword page) :ento)))
    ;; Everything is drawn inside the one theme, the sign-in screen
    ;; included - it is the first thing anybody sees and there is no reason
    ;; for it to be the one screen that looks like something else.
    ($ mui/Frame
       ($ screen/Screen))))

(defonce ROOT
  (delay
    (let [element (js/document.getElementById "root")]
      (kc/assert element ::root-element-missing)
      (rdom/createRoot element))))

(defn render! []
  (-> @ROOT (.render ($ App))))

(defn after-load! [] (render!))

(defn main! []
  (spa/init-router)
  (spa/location-materialize!)
  (keyboard/install!)
  (pwa/install!)
  (window/start!)
  (render!))
